export default "__VITE_ASSET__D5X5x8B8__"